import { useAppDispatch } from '../redux/hooks';
import { invalidTokenModalActions } from '../redux/slices/invalid-token-modal-slice';
import SnackbarUtils from '../utils/SnackbarUtils';
import i18n from 'i18next';
import storageService, { Locals } from '../utils/storageService';
import { isNullOrUndefined } from '../utils/utils';

let dispatch = null;
export const GlobalErrorConfiguration = () => {
    dispatch = useAppDispatch();
    return null;
};

const handleErrorRequest = (error) => {
    if (Array.isArray(error.data.errors)) {
        // handle Shopify or BC error
        SnackbarUtils.error(error.data.errors[0]);
    } else {
        // handle registration / form validation error, check for translate
        let errorKey = Object.keys(error.data.errors)[0];
        const firstError = error.data.errors[errorKey][0];
        if (errorKey.includes('.')) {
            //nested error key...
            errorKey = errorKey.split('.')[0];
        }
        const errorKeyString =
            'ERROR.FORM_VALIDATION_ERRORS.' +
            errorKey.toUpperCase() +
            '.' +
            firstError.toUpperCase();

        SnackbarUtils.error(
            i18n.exists(errorKeyString, {
                ns: 'errors',
            })
                ? i18n.t(errorKeyString, { ns: 'errors' })
                : !isNullOrUndefined(error.data.message)
                ? error.data.message
                : i18n.t('ERROR.GLOBAL_ERROR', { ns: 'errors' })
        );
    }
};

export default {
    handleError(error: { data: any; status: number }) {
        switch (true) {
            case error.status === 404:
                return;
            case error.status === 401:
                if (storageService.getItem(Locals.ACCESS_TOKEN)) {
                    //session expired
                    dispatch(invalidTokenModalActions.showModal());
                } else {
                    //invalid login
                    SnackbarUtils.error(
                        i18n.t('ERROR.LOGIN_ERROR', { ns: 'errors' })
                    );
                }
                return;
            case !isNullOrUndefined(error.data.message):
                if (error.data && error.data.errors) {
                    handleErrorRequest(error);
                    return;
                }
                if (
                    i18n.exists('ERROR.' + error.data.message, {
                        ns: 'errors',
                    })
                ) {
                    SnackbarUtils.error(
                        i18n.t('ERROR.' + error.data.message, {
                            ns: 'errors',
                        })
                    );
                } else {
                    SnackbarUtils.error(error.data.message);
                }
                return;
            default:
                SnackbarUtils.error(
                    i18n.t('ERROR.GLOBAL_ERROR', { ns: 'errors' })
                );
        }
    },
};
